import { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Navbar";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";

const IMG = "https://images.pexels.com/photos/38329933/pexels-photo-38329933.jpeg?auto=compress&cs=tinysrgb&w=1200";

export default function AuthPage({ mode }) {
  const isReg = mode === "register";
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { user, signIn } = useAuth();
  const nav = useNavigate();
  if (user) return <Navigate to="/studio" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const { data } = await api.post(`/auth/${isReg ? "register" : "login"}`, isReg ? form : { email: form.email, password: form.password });
      signIn(data);
      nav("/studio");
    } catch (err) {
      setError(errMsg(err));
    } finally { setLoading(false); }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#09090b]" data-testid={`${mode}-page`}>
      <div className="flex flex-col p-8 lg:p-14">
        <Logo />
        <form onSubmit={submit} className="my-auto w-full max-w-sm mx-auto space-y-5 fade-up" data-testid="auth-form">
          <div>
            <h1 className="text-3xl font-extrabold text-white">{isReg ? "Crea tu cuenta" : "Bienvenido de nuevo"}</h1>
            <p className="text-zinc-400 text-sm mt-2">{isReg ? "Incluye 1 video de prueba gratis de 15 segundos." : "Entra para seguir creando videos."}</p>
          </div>
          {isReg && <div className="space-y-2"><Label>Nombre</Label><Input data-testid="auth-name-input" value={form.name} onChange={set("name")} required className="h-11 bg-zinc-900/60" /></div>}
          <div className="space-y-2"><Label>Email</Label><Input data-testid="auth-email-input" type="email" value={form.email} onChange={set("email")} required className="h-11 bg-zinc-900/60" /></div>
          <div className="space-y-2"><Label>Contraseña</Label><Input data-testid="auth-password-input" type="password" minLength={6} value={form.password} onChange={set("password")} required className="h-11 bg-zinc-900/60" /></div>
          {error && <p className="text-sm text-red-400" data-testid="auth-error">{error}</p>}
          <Button data-testid="auth-submit-btn" disabled={loading} className="w-full h-11 rounded-full bg-[#E8C47C] hover:bg-[#F3D9A4] text-black font-semibold">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : isReg ? "Crear cuenta" : "Entrar"}
          </Button>
          <p className="text-sm text-zinc-500 text-center">
            {isReg ? "¿Ya tienes cuenta? " : "¿No tienes cuenta? "}
            <Link to={isReg ? "/login" : "/register"} className="text-[#E8C47C] hover:text-[#E8C47C]" data-testid="auth-switch-link">{isReg ? "Entrar" : "Regístrate gratis"}</Link>
          </p>
        </form>
      </div>
      <div className="hidden lg:block relative">
        <img src={IMG} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#09090b] via-[#09090b]/30 to-transparent" />
        <p className="absolute bottom-14 left-14 right-14 font-anton text-4xl uppercase text-white leading-tight">Del guion al video <span className="text-yellow-300">en minutos</span></p>
      </div>
    </div>
  );
}
